import React, { useState, useEffect} from "react";
import { makeStyles,withStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import LoadingOverlay from 'react-loading-overlay';

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function AddSupplierModal(props) {
	const classes = useStyles();
	// const [open, setOpen] = useState(false);
	const {overLayMsg, open} = props;

	const handleOpen = () => {
		//setOpen(true);
	};

	const handleClose = () => {
		//setOpen(false);
		return false;
	};


	return (
		<div>
			{/* <Button style={{minWidth: "190px",marginBottom:"0.5em", marginRight:"0.5em"}} variant="outlined" color="primary" onClick={handleOpen}>
				Add Item Order
			</Button> */}
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
				<div style={{minWidth:"300px"}}>
					<LoadingOverlay
			    	active={open}
					spinner
					text={overLayMsg}
					>
					</LoadingOverlay>
				</div>
				</Fade>
			</Modal>
		</div>
	);
}
